import QualifyScreen from 'features/believe/application/QualifyScreen/QualifyScreen';
import React from 'react';

export default function CardApplicationFailPage() {
  return <QualifyScreen />;
}
